// Utility to handle redirects from old domain to new domain
export const handleDomainRedirect = () => {
  const currentHost = window.location.host;
  const currentUrl = window.location.href;
  
  // Check if user is on the old domain
  if (currentHost.includes('jrt-crm-frontend.onrender.com')) {
    const newUrl = currentUrl.replace(
      'jrt-crm-frontend.onrender.com', 
      'driver.jrtroofing.com'
    );
    
    console.log(`Client-side redirect: ${currentUrl} -> ${newUrl}`);
    
    // Redirect to new domain
    window.location.replace(newUrl);
    return true;
  }
  
  return false;
};

// Auto-execute on import
if (typeof window !== 'undefined') {
  handleDomainRedirect();
} 